import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-flag-emoji',
  template: `{{ getFlagEmoji(countryCode) }}`,
  styles: []
})
export class FlagEmojiComponent {
  @Input() countryCode: string = 'US'; // Default to US, but this should be dynamically set based on the user's country

  getFlagEmoji(countryCode: string): string {
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map(char =>  127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  }
}
